import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light:{
        primary: "#1a4ea2",
        secondary: "#1480BA",
        accent: "#13A2B0",
        error: "#A33A2A",
        warning: "#ffeb3b",
        info: "#052457",
        success: "#7BA30A"
        }
    },
  },
});
